import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-117da32c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overview content-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Willkommen bei ChatCaptain!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hier findest du eine Übersicht mit allen Funktionen.", -1))
const _hoisted_4 = { class: "items-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "In dieser Demo verfügbar", -1))
const _hoisted_6 = { class: "items" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "material-icons-round" }
const _hoisted_9 = {
  key: 0,
  class: "items-wrapper"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Demnächst verfügbar", -1))
const _hoisted_11 = { class: "items" }
const _hoisted_12 = { class: "material-icons-round" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_tabs = _resolveComponent("md-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_md_tabs, {
      title: "Übersicht",
      "title-only": true
    }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeItems, (item, k) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item", { disabled: item.disabled }]),
              key: k,
              onClick: ($event: any) => (_ctx.onItemClick(item))
            }, [
              _createElementVNode("i", _hoisted_8, _toDisplayString(item.icon), 1),
              _createElementVNode("h2", null, _toDisplayString(item.title), 1),
              _createElementVNode("p", null, _toDisplayString(item.description), 1)
            ], 10, _hoisted_7))
          }), 128))
        ])
      ]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disabledItems, (item, k) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["item", { disabled: item.disabled }]),
                  key: k
                }, [
                  _createElementVNode("i", _hoisted_12, _toDisplayString(item.icon), 1),
                  _createElementVNode("h2", null, _toDisplayString(item.title), 1),
                  _createElementVNode("p", null, _toDisplayString(item.description), 1)
                ], 2))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}